import { z } from "zod";

export const widgetConfigSchema = z.object({
  clientId: z.string().min(1),
  redirectUri: z.string().min(1),
  logouturl: z.string().min(1),
  responseType: z.string().default("code"),

  scope: z.string().default("email openid"),
  chatbot: z
    .preprocess((v) => {
      if (typeof v === "boolean") return v;
      if (typeof v === "string") return v.trim().toLowerCase() === "true";
      return false;
    }, z.boolean())
    .default(false),
  goto: z.string().optional(),
  gotoFail: z.string().optional(),
  provisioning: z.string().optional(),
  qrCode: z.string().optional(),
  altTheme: z.string().optional(),
  codeChallenge: z.string().optional(),
  codeChallengeMethod: z.string().optional(),
  state: z.string().optional(),

  triggerElementId: z.string().min(1).optional(),
  language: z.enum(["el", "en"]).optional().default("el"),
  // Logged-out avatar override temporarily disabled:
  // avatarUrl: z.url().optional(),
  // avatarWidth: z
  //   .union([z.string(), z.number()])
  //   .optional()
  //   .transform(parseOptionalAvatarWidthPx),

  /** Already-logged-in sessionStorage cache lifetime (minutes). `0` disables. Set via `data-cache-breaker-min` (string). */
  cacheBreakerMin: z
    .preprocess((v) => {
      if (v === undefined || v === null || v === "") return undefined;
      if (typeof v !== "string") return undefined;
      const n = Number.parseInt(v.trim(), 10);
      return Number.isFinite(n) ? n : undefined;
    }, z.number().int().min(0).max(60).optional())
    .optional(),
});

export type WidgetConfig = z.infer<typeof widgetConfigSchema>;
